import React from 'react';

import {
    BoxGrid,
} from 'reaxl';

function GridComponent({ isPsx, children, ...rest }) {
    if (isPsx) {
        // We do not want the full box-grid capabilities
        // just basic spacing
        return (
            <div
                className="box-grid"
                {...rest}
            >
                {children}
            </div>
        );
    }

    return (<BoxGrid {...rest}>{children}</BoxGrid>);
}

export default GridComponent;
